interface Props {
  initial: string;
}

export function TypingIndicator({ initial }: Props) {
  return (
    <div className="flex items-end gap-2 animate-fade-in-up">
      <div
        className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-[11px] font-bold text-white"
        style={{ backgroundColor: 'var(--brand-accent)' }}
      >
        {initial}
      </div>
      <div
        className="flex items-center gap-1 bg-accent-light px-3.5 py-3"
        style={{ borderRadius: '4px 18px 18px 18px' }}
      >
        {[0, 1, 2].map((i) => (
          <span
            key={i}
            className="h-1.5 w-1.5 rounded-full bg-mid/60 animate-bounce-dot"
            style={{ animationDelay: `${i * 0.16}s` }}
          />
        ))}
      </div>
    </div>
  );
}

export default TypingIndicator;
